/* SOLÉA BARE · Home interactions (reveal, before/after, shade finder, UGC video, inline capture) */
(function () {
  if (window.__sbHome) return;
  window.__sbHome = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sb-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Before / after slider */
  function initBA(root) {
    (root || document).querySelectorAll('[data-sb-ba]').forEach(function (frame) {
      if (frame.dataset.ready) return;
      frame.dataset.ready = '1';
      var range = frame.querySelector('input[type=range]');
      var set = function () { frame.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  /* Shade finder */
  function initShade(root) {
    (root || document).querySelectorAll('[data-sb-shade]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var opts = box.querySelectorAll('[data-shade]');
      var name = box.querySelector('[data-shade-name]');
      var desc = box.querySelector('[data-shade-desc]');
      var img = box.querySelector('[data-shade-img]');
      var cta = box.querySelector('[data-shade-cta]');
      var chip = box.querySelector('[data-shade-chip]');
      function pick(btn) {
        opts.forEach(function (o) { o.setAttribute('aria-pressed', o === btn ? 'true' : 'false'); });
        name.textContent = btn.dataset.label;
        desc.textContent = btn.dataset.desc;
        if (btn.dataset.img) { img.src = btn.dataset.img; img.alt = btn.dataset.label + ' nipple covers'; }
        if (chip) chip.textContent = btn.dataset.label;
        cta.href = btn.dataset.url;
        cta.querySelector('span').textContent = 'Shop ' + btn.dataset.label;
      }
      opts.forEach(function (o) { o.addEventListener('click', function () { pick(o); }); });
    });
  }

  /* UGC: play videos only while visible; tap to toggle sound */
  function initUGC(root) {
    var vids = (root || document).querySelectorAll('[data-sb-ugc] video');
    if (!vids.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.src && v.dataset.src) v.src = v.dataset.src;
          if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else { v.pause(); }
      });
    }, { threshold: 0.35 }) : null;
    vids.forEach(function (v) {
      if (v.dataset.ready) return;
      v.dataset.ready = '1';
      if (io) io.observe(v); else if (v.dataset.src) v.src = v.dataset.src;
      var btn = v.parentElement.querySelector('.sb-ugc__sound');
      if (btn) btn.addEventListener('click', function () {
        var on = v.muted;
        vids.forEach(function (o) { o.muted = true; o.parentElement.classList.remove('is-sound'); });
        v.muted = !on;
        if (on) { v.parentElement.classList.add('is-sound'); v.play(); }
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  /* Inline email capture: submit via fetch so the visitor stays on the page */
  function initCapture(root) {
    (root || document).querySelectorAll('[data-sb-capture] form').forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      form.addEventListener('submit', function (e) {
        var email = form.querySelector('input[type=email]');
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) return;
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        var btn = form.querySelector('button');
        if (btn) btn.disabled = true;
        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
          .then(function (r) {
            if (/\/challenge/.test(r.url)) { HTMLFormElement.prototype.submit.call(form); return; }
            var wrap = form.closest('[data-sb-capture]');
            wrap.classList.add('is-done');
            try { var s = JSON.parse(localStorage.getItem('sbw_state') || '{}'); s.subscribed = true; localStorage.setItem('sbw_state', JSON.stringify(s)); } catch (err) {}
          })
          .catch(function () { HTMLFormElement.prototype.submit.call(form); });
      });
    });
  }


  /* Fit quiz: style → cup → shade → pairs → exact variant or set */
  function initQuiz(root) {
    (root || document).querySelectorAll('[data-sb-quiz]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var sec = box.closest('section');
      var dataEl = sec && sec.querySelector('[data-sb-quiz-data]');
      if (!dataEl) return;
      var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var order = ['style', 'cup', 'shade', 'pairs', 'result'];
      var labels = { LightNude: 'Light Nude', Honey: 'Honey', Foundation: 'Foundation', Caramel: 'Caramel', Coffee: 'Coffee' };
      var deeper = { LightNude: 'Honey', Honey: 'Foundation', Foundation: 'Caramel', Caramel: 'Coffee', Coffee: 'Caramel' };
      var ans = {}, step = 0;
      var qs = {}; box.querySelectorAll('[data-q]').forEach(function (q) { qs[q.dataset.q] = q; });
      var bar = box.querySelector('[data-bar]'), count = box.querySelector('[data-count]'), back = box.querySelector('[data-back]');
      var dots = box.querySelectorAll('[data-dot]');

      function show(i) {
        step = i;
        order.forEach(function (k, n) { qs[k].classList.toggle('is-on', n === i); });
        bar.style.width = Math.min(100, (i / 4) * 100) + '%';
        count.textContent = i < 4 ? 'Question ' + (i + 1) + ' of 4' : ''; count.hidden = i >= 4;
        back.hidden = i === 0 || i === 4;
        dots.forEach(function (d, n) { d.classList.toggle('is-done', n < i); d.classList.toggle('is-on', n === i); });
      }

      function find(shape, size, color) {
        var p = data.products[shape]; if (!p) return null;
        for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i];
          if (v.size === size && v.color === color && v.available) return v;
        }
        return null;
      }

      function result() {
        var shape = ans.style === 'triangle' ? 'triangle' : 'circle';
        var size, note = '';
        if (shape === 'circle') size = ans.cup === 'ab' ? '8 CM' : '10 CM';
        else size = ans.cup === 'd' ? '13 CM' : '10 CM';
        var color = ans.shade;
        var v = find(shape, size, color);
        if (!v && shape === 'triangle' && size === '13 CM') {
          size = '10 CM'; v = find(shape, size, color);
          note = 'Our Bare Sculpt 13 cm is back soon — the 10 cm gives you the same sculpted shape in the meantime.';
        }
        if (!v && shape === 'circle' && size === '8 CM') {
          var v10 = find(shape, '10 CM', color);
          if (v10) { size = '10 CM'; v = v10; note = labels[color] + ' comes in our 10 cm Circle — a touch more coverage, same invisible finish.'; }
        }
        if (!v) {
          var alt = deeper[color], va = find(shape, size, alt);
          if (va) { note = labels[color] + ' isn’t available in this shape and size, so we matched you with ' + labels[alt] + ', the closest shade.'; color = alt; v = va; }
        }
        var p = data.products[shape];
        var name = p.title + ' · ' + size.replace(' CM', ' cm') + ' · ' + labels[color];
        var why = shape === 'circle'
          ? (ans.style === 'mix' ? 'Our most versatile shape — smooth under almost everything you own.' : 'Smooth, natural coverage that disappears under fitted tees and knits.')
          : 'Edges that follow plunging, halter and asymmetrical cuts.';
        var cta = box.querySelector('[data-r-cta]'), price = box.querySelector('[data-r-price]');
        if (ans.pairs === '2' || ans.pairs === '3') {
          var set = data.sets[ans.pairs];
          var tip = ans.style === 'mix' ? 'Tip: make one pair Bare Essential and one Bare Sculpt so you’re covered for every neckline.' : 'Start your set with ' + name + '.';
          why += ' ' + tip;
          name = set.title + ' — starting with ' + p.title + ' ' + size.replace(' CM', ' cm') + ' in ' + labels[color];
          price.textContent = set.price + ' for ' + ans.pairs + ' pairs';
          cta.href = set.url;
          cta.firstChild.textContent = 'Build my ' + set.title.replace(/^The /, '') + ' ';
        } else {
          price.textContent = p.price;
          cta.href = v ? v.url : p.url;
          cta.firstChild.textContent = 'Shop my match ';
        }
        box.querySelector('[data-r-name]').textContent = name;
        box.querySelector('[data-r-why]').textContent = why;
        var img = box.querySelector('[data-r-img]');
        if (v && v.img) { img.src = v.img; img.alt = labels[color] + ' ' + p.title + ' nipple covers'; img.parentElement.hidden = false; } else { img.parentElement.hidden = true; }
        var n = box.querySelector('[data-r-note]'); n.textContent = note; n.hidden = !note;
        try { var s = JSON.parse(localStorage.getItem('sb_match') || '{}'); s = { shape: shape, size: size, color: color, pairs: ans.pairs }; localStorage.setItem('sb_match', JSON.stringify(s)); } catch (e) {}
      }

      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-v]');
        if (b && box.contains(b)) {
          var k = order[step]; ans[k] = b.dataset.v;
          b.parentElement.querySelectorAll('[data-v]').forEach(function (o) { o.classList.toggle('is-picked', o === b); });
          if (step === 3) result();
          setTimeout(function () { show(step + 1); }, 160);
          return;
        }
        if (e.target.closest('[data-back]')) show(Math.max(0, step - 1));
        if (e.target.closest('[data-restart]')) { ans = {}; box.querySelectorAll('.is-picked').forEach(function (o) { o.classList.remove('is-picked'); }); show(0); }
      });
      show(0);
    });
  }


  /* Mobile quick add (home): sticky bar → bottom sheet → AJAX add to cart */
  function initQuickAdd(root) {
    var box = (root || document).querySelector('[data-sb-qa]');
    if (!box || box.dataset.ready) return;
    box.dataset.ready = '1';
    var data; try { data = JSON.parse(box.querySelector('[data-qa-data]').textContent); } catch (e) { return; }
    var labels = { LightNude: 'Light Nude', Honey: 'Honey', Foundation: 'Foundation', Caramel: 'Caramel', Coffee: 'Coffee' };
    var hex = { LightNude: '#efc9aa', Honey: '#e2a970', Foundation: '#d39780', Caramel: '#c48557', Coffee: '#8b5a33' };
    var order = ['LightNude', 'Honey', 'Foundation', 'Caramel', 'Coffee'];
    var sel = { shape: 'circle', size: '10 CM', color: 'Honey' };
    try { var m = JSON.parse(localStorage.getItem('sb_match') || 'null'); if (m && m.shape) sel = { shape: m.shape, size: m.size, color: m.color }; } catch (e) {}
    var q = function (s) { return box.querySelector(s); };
    var bar = q('[data-qa-bar]'), sheet = q('.sb-qa__sheet');

    function variants(shape) { return (data[shape] || { variants: [] }).variants; }
    function find(shape, size, color) { return variants(shape).filter(function (v) { return v.size === size && v.color === color; })[0]; }
    function sizes(shape) { var out = []; variants(shape).forEach(function (v) { if (out.indexOf(v.size) < 0) out.push(v.size); }); return out; }
    function sizeOk(shape, size) { return variants(shape).some(function (v) { return v.size === size && v.available; }); }
    function fix() {
      if (!sizeOk(sel.shape, sel.size)) { var s = sizes(sel.shape).filter(function (z) { return sizeOk(sel.shape, z); }); sel.size = s.indexOf('10 CM') > -1 ? '10 CM' : s[0]; }
      var v = find(sel.shape, sel.size, sel.color);
      if (!v || !v.available) { var a = variants(sel.shape).filter(function (x) { return x.size === sel.size && x.available; }); if (a.length) sel.color = a[0].color; }
    }
    function render() {
      fix();
      var v = find(sel.shape, sel.size, sel.color);
      q('[data-qa-shape]').querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.v === sel.shape ? 'true' : 'false'); });
      q('[data-qa-size]').innerHTML = sizes(sel.shape).map(function (z) {
        var ok = sizeOk(sel.shape, z);
        return '<button type="button" data-v="' + z + '" aria-pressed="' + (z === sel.size) + '"' + (ok ? '' : ' disabled') + '>' + z.replace(' CM', ' cm') + (ok ? '' : '<small>Back soon</small>') + '</button>';
      }).join('');
      q('[data-qa-shades]').innerHTML = order.map(function (c) {
        var x = find(sel.shape, sel.size, c); if (!x) return '';
        return '<button type="button" data-v="' + c + '" aria-pressed="' + (c === sel.color) + '"' + (x.available ? '' : ' disabled') + ' aria-label="' + labels[c] + '"><i style="background:' + hex[c] + '"></i></button>';
      }).join('');
      q('[data-qa-shade-name]').textContent = '· ' + labels[sel.color];
      q('[data-qa-name]').textContent = data[sel.shape].title + ' · ' + sel.size.replace(' CM', ' cm') + ' · ' + labels[sel.color];
      q('[data-qa-price]').textContent = v ? v.price : '';
      var img = q('[data-qa-img]'); if (v && v.img) { img.src = v.img; img.alt = labels[sel.color] + ' ' + data[sel.shape].title; }
      var add = q('[data-qa-add]'); add.disabled = !(v && v.available); add.textContent = v && v.available ? 'Add to cart · ' + v.price : 'Sold out';
    }
    function open() { try { var m2 = JSON.parse(localStorage.getItem('sb_match') || 'null'); if (m2 && m2.shape) sel = { shape: m2.shape, size: m2.size, color: m2.color }; } catch (e) {} render(); q('[data-qa-pick]').hidden = false; q('[data-qa-done]').hidden = true; box.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; setTimeout(function () { sheet.focus(); }, 50); }
    function close() { box.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-qa-open]')) return open();
      if (e.target.closest('[data-qa-close]')) return close();
      var b = e.target.closest('button[data-v]'); if (!b || b.disabled) return;
      var grp = b.parentElement;
      if (grp.matches('[data-qa-shape]')) sel.shape = b.dataset.v;
      else if (grp.matches('[data-qa-size]')) sel.size = b.dataset.v;
      else if (grp.matches('[data-qa-shades]')) sel.color = b.dataset.v;
      render();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('is-open')) close(); });

    q('[data-qa-add]').addEventListener('click', function () {
      var v = find(sel.shape, sel.size, sel.color); if (!v) return;
      var btn = this, err = q('[data-qa-err]'); btn.disabled = true; btn.textContent = 'Adding…'; err.hidden = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: 'cart-icon-bubble' }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && j.sections && j.sections['cart-icon-bubble']) {
            var tmp = document.createElement('div'); tmp.innerHTML = j.sections['cart-icon-bubble'];
            var inner = tmp.querySelector('.shopify-section') || tmp; bubble.innerHTML = inner.innerHTML;
          }
          q('[data-qa-added]').textContent = q('[data-qa-name]').textContent;
          q('[data-qa-pick]').hidden = true; q('[data-qa-done]').hidden = false;
        })
        .catch(function (j) { err.textContent = (j && j.description) || 'Something went wrong. Please try again.'; err.hidden = false; })
        .then(function () { render(); });
    });

    /* show the bar only after the hero call-to-action has scrolled away */
    box.hidden = false;
    var cta = document.querySelector('.sb-hero__cta');
    if (cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { box.classList.toggle('is-shown', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(cta);
    } else { box.classList.add('is-shown'); }
  }

  function init(root) { initReveal(root); initBA(root); initShade(root); initUGC(root); initCapture(root); initQuiz(root); initQuickAdd(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
